import styled from 'styled-components'

export const DevModeOverlayStyles = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999999;
`
